export default {
  switchboard: 'Switchboard',
};
